/* eslint-disable no-use-before-define */
import qs from 'querystring';
import axios from 'axios';
import moment from 'moment';
import _ from 'underscore';
import client from './rest/AdminClient';
// Initial Fetch with Lanes, Lane Rates, and Shipments per Lane
export const getLaneData = function (filters = {}) {
    return new Promise((resolve, reject) => {
        client({
            method: 'GET',
            path: `/admin/api/offer-planner/lanes?${qs.stringify(filters)}`,
        }).then((response) => {
            resolve(response.entity.results);
        }, (response) => {
            reject(response.entity);
        });
    });
};
export const getShipments = function (query) {
    return new Promise((resolve, reject) => {
        client({
            method: 'GET',
            path: `/admin/api/offer-planner/shipments?${qs.stringify(query)}`,
        }).then((response) => {
            resolve(response.entity.results);
        }, (response) => {
            reject(response.entity);
        });
    });
};
export const getLaneDataV2 = (query) => {
    return _getLaneDataV2(query)
        .then(function (res) {
        if (res && res.data) {
            return res.data;
        }
        throw new Error('location service API error');
    })
        .catch(function (err) {
        console.log(err.stack || err);
        return err;
    });
};
const _getLaneDataV2 = (filters) => {
    const formattedQuery = _.pick(filters, [
        'originZone',
        'destinationZone',
        'markets',
    ]);
    const today = moment().toISOString(); // .subtract(1, 'month').toISOString();
    const dateQuery = Object.assign({ status: 'confirmed', per_page: 3000, customerType: 'carrier' }, formattedQuery);
    const dateQueryString = qs.stringify(dateQuery);
    const url = `${PRICING_SERVICE_HOST}/lanes/user/v2/rates?${dateQueryString}`;
    const options = {
        method: 'get',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            // eslint-disable-next-line no-undef
            'x-api-key': PRICING_SERVICE_API_KEY,
        },
    };
    return axios(options);
};
// Get all the carriers operating in the lane's market
export const getCarriersByMarket = function (body) {
    const { originZip, destinationZip } = body;
    return new Promise((resolve, reject) => {
        client({
            method: 'POST',
            path: `/admin/api/offer-planner/carriers/market`,
            entity: JSON.stringify({ originZip, destinationZip }),
        }).then((response) => {
            resolve(response.entity);
        }, (response) => {
            reject(response.entity);
        });
    });
};
export const getCarriersByMarketV2 = function (body) {
    const { lanes } = body;
    return new Promise((resolve, reject) => {
        client({
            method: 'POST',
            path: `/admin/api/offer-planner/carriers/v2/market`,
            entity: JSON.stringify({ lanes }),
        }).then((response) => {
            resolve(response.entity);
        }, (response) => {
            reject(response.entity);
        });
    });
};
// Get carriers that have offers for shipments in the current lane
export const getCarriersWithOfferV2 = function (body) {
    const { lanes } = body;
    return new Promise((resolve, reject) => {
        client({
            method: 'POST',
            path: `/admin/api/offer-planner/carriers/v2/offers`,
            entity: JSON.stringify({ lanes }),
        }).then((response) => {
            resolve(response.entity);
        }, (response) => {
            reject(response.entity);
        });
    });
};
// Get carriers that have offers for shipments in the current lane
export const getCarriersWithOffer = function (body) {
    const { shipmentIds } = body;
    return new Promise((resolve, reject) => {
        client({
            method: 'POST',
            path: `/admin/api/offer-planner/carriers/offers`,
            entity: JSON.stringify({ shipmentIds }),
        }).then((response) => {
            resolve(response.entity);
        }, (response) => {
            reject(response.entity);
        });
    });
};
// For all carrier lane rates with weekly commitment, check how many shipments they have in progress
export const getCommitmentDispatched = function (body) {
    const { shipper, origin, destination } = body;
    return new Promise((resolve, reject) => {
        client({
            method: 'POST',
            path: `/admin/api/offer-planner/commitment`,
            entity: JSON.stringify({ shipper, origin, destination }),
        }).then((response) => {
            resolve(response.entity);
        }, (response) => {
            reject(response.entity);
        });
    });
};
export const sendOfferEmail = async function (body) {
    const { carrier, jobs } = body;
    return new Promise((resolve, reject) => {
        client({
            method: 'POST',
            path: `/admin/api/offer-planner/send-offer-email`,
            entity: JSON.stringify({ carrier, offers: jobs }),
        }).then((response) => {
            resolve(response.entity);
        }, (response) => {
            reject(response.entity);
        });
    });
};
export const sendAssignedEmail = async function (body) {
    const { carrier, jobs } = body;
    return new Promise((resolve, reject) => {
        client({
            method: 'POST',
            path: `/admin/api/offer-planner/send-assigned-email`,
            entity: JSON.stringify({ carrier, shipments: jobs }),
        }).then((response) => {
            resolve(response.entity);
        }, (response) => {
            reject(response.entity);
        });
    });
};
